import React from 'react'
import "./bar.css"
const Bar = ({number}) => {
  return (
   <div className='flex justify-center  font-bold sm:mr-16 md:mr-0 xxs:mr-9 mt-3'>
  <div className="div border text-center">
    <p id="h2">{number}<span id="lol" /></p>
  </div>
</div>

  )
}

export default Bar
